import { useParams } from 'react-router-dom';

import useUserPid from '@/features/auth/hooks/use-user-pid';
import FcaQuestionnaireForm from '@/features/onboarding/fca-questionnaire/components/form';
import BaseLayout from '@/layouts/base';
import ErrorPage from '@/pages/error';
import LoadingPage from '@/pages/loading';

const FcaQuestionnaireRetakePage = () => {
  const { isLoading: isLoadingPid, pid } = useUserPid();
  const { pid: paramsPid } = useParams();

  if (isLoadingPid) return <LoadingPage />;

  if (!paramsPid || paramsPid !== pid) return <ErrorPage />;

  return (
    <BaseLayout>
      <FcaQuestionnaireForm />
    </BaseLayout>
  );
};
FcaQuestionnaireRetakePage.displayName = 'FcaQuestionnaireRetakePage';

export default FcaQuestionnaireRetakePage;
